export const getCarouselTitleWithFallback = ({ cardData }) =>
  cardData?.sectionHeadline?.title ?? '';
